import React from "react";
import { useTranslation } from "react-i18next";
import {
  createFileRoute,
  Outlet,
  useChildMatches,
} from "@tanstack/react-router";

// ui
import { AppShell, Stack, Title, Center } from "@mantine/core";
import { SpringOnboardingTitle } from "@components/Typography";
import { useColors } from "@utils/useColors";

export const Route = createFileRoute("/spring-health")({
  component: SpringRegistrationLayout,
});

function SpringHealthHeader() {
  const { t } = useTranslation();
  const themeColors = useColors();

  return (
    <Center p="md">
      <Stack gap="xs" align="center">
        <Title ff="Rammetto One" fw="400" c={themeColors.tufts100}>
          MIGHTIER
        </Title>
        <SpringOnboardingTitle order={2}>
          {t("springHealth.layout.header")}
        </SpringOnboardingTitle>
      </Stack>
    </Center>
  );
}

function SpringRegistrationLayout() {
  const isVerifyPage = useChildMatches({
    select: (matches) => {
      return matches.some((match) => match.routeId === "/spring-health/verify");
    },
  });

  return (
    <AppShell>
      <AppShell.Main mt={{ xs: "xs", md: "xl" }} px={{ xs: "xs", sm: "8%" }}>
        {isVerifyPage ? null : <SpringHealthHeader />}
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
